import { render, staticRenderFns } from "./MyPedigrees.vue?vue&type=template&id=2e0168fe"
import script from "./MyPedigrees.vue?vue&type=script&lang=ts"
export * from "./MyPedigrees.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports